import userProfileFragment from 'Root/App/Item/UserProfile/user-profile.graphql'

import { useState } from 'react'

import { useQuery, gql } from '@apollo/client'

const GET_ELEMENT_AUTHORIZATION_FOR_GROUPS = gql`
  ${userProfileFragment}
  query GetElementAuthorizationForGroups($id: ID!) {
    element(id: $id) {
      __typename
      ... on Collection {
        id
        authorizationsGroups {
          id
          group {
            id
            name
            usersCount
          }
          value
        }
        creator {
          ...UserProfile
          email
          workspace {
            id
            name
          }
        }
      }
      ... on Content {
        id
        authorizationsGroups {
          id
          group {
            id
            name
            usersCount
          }
          value
        }
        creator {
          ...UserProfile
          email
          workspace {
            id
            name
          }
        }
      }
      ... on Folder {
        id
        authorizationsGroups {
          id
          group {
            id
            name
            usersCount
          }
          value
        }
        creator {
          ...UserProfile
          email
          workspace {
            id
            name
          }
        }
      }
    }
  }
`

const GET_GROUPS_BY_WORKSPACE = gql`
  query GroupsByWorkspace($workspaceId: ID!) {
    groupsByWorkspace(workspaceId: $workspaceId) {
      id
      name
      description
      usersCount
    }
  }
`

export const useElementAuthorizationForGroups = (elementId: string) => {
  const [workspaceId, setWorkspaceId] = useState<string | null>(null)

  const {
    data: elementData,
    loading: loadingElement,
    error: errorElement,
  } = useQuery(GET_ELEMENT_AUTHORIZATION_FOR_GROUPS, {
    variables: { id: elementId },
    onCompleted: (data) => {
      const element = data?.element
      const workspace = element?.creator?.workspace
      if (workspace?.id) {
        setWorkspaceId(workspace.id)
      }
    },
  })

  const {
    data: groupsData,
    loading: loadingGroups,
    error: errorGroups,
  } = useQuery(GET_GROUPS_BY_WORKSPACE, {
    variables: { workspaceId: workspaceId! },
    skip: !workspaceId,
  })

  return {
    authorizationsGroups: elementData?.element?.authorizationsGroups || null,
    groups: groupsData?.groupsByWorkspace || [],
    loading: loadingElement || loadingGroups,
    error: errorElement || errorGroups,
  }
}
